//
//
//
//
//
//
//
//
//
//
//
//
import textMixin from "./mixins/text.js";
export default {
  mixins: [textMixin],
  props: {
    spec: {
      type: Object,
      required: true
    }
  }
};